import React from 'react'
import styles from './matchCardS1x3.module.css'
import  { Match } from '../../types/matchTypes'
import MatchCardS from "../matchCardS/matchCardS";

interface MatchCardProps {
	matches: Match[]
}

const MatchCardS1x3: React.FC<MatchCardProps> = ({ matches }) => {
	return (
		<ul className={styles.matches_S}>
			{matches.map((match) => (
				<MatchCardS match={match} key={match.id} />
			))}
		</ul>
	)
}

export default MatchCardS1x3
